<template>
    <div>
        <password-input
            v-model="localValue"
            :autofocus="true"
            :label="lang('Nytt lösenord','New password')"
            :name="name"
            autocomplete="new-password"
            :can-toggle-visibility="true"
            :show-password-strength="false"
            :tabindex="1"
        >
            <template v-slot="{ password }">
                <div class="my-lg font-regular">
                    <div class="mt-sm">
                        <font-awesome-icon
                            icon="check-circle"
                            class="mr-xs"
                            :class="{'text-success': passwordHasLowercase(password), 'text-neutral-light': ! passwordHasLowercase(password) }"
                        />
                        {{ lang('En liten bokstav', 'A lowercase letter') }}
                    </div>
                    <div class="mt-sm">
                        <font-awesome-icon
                            icon="check-circle"
                            class="mr-xs"
                            :class="{'text-success': passwordHasUppercase(password), 'text-neutral-light': ! passwordHasUppercase(password) }"
                        />
                        {{ lang('En stor bokstav', 'An uppercase letter') }}
                    </div>
                    <div class="mt-sm">
                        <font-awesome-icon
                            icon="check-circle"
                            class="mr-xs"
                            :class="{'text-success': passwordHasSpecialCharacter(password), 'text-neutral-light': ! passwordHasSpecialCharacter(password) }"
                        />
                        {{ lang('Ett specialtecken', 'A special character') }}
                    </div>
                    <div class="mt-sm">
                        <font-awesome-icon
                            icon="check-circle"
                            class="mr-xs"
                            :class="{'text-success': passwordHasNumber(password), 'text-neutral-light': ! passwordHasNumber(password) }"
                        />
                        {{ lang('En siffra', 'A number') }}
                    </div>
                    <div class="mt-sm">
                        <font-awesome-icon
                            icon="check-circle"
                            class="mr-xs"
                            :class="{'text-success': passwordHasLengthSpan(password, 16, 32), 'text-neutral-light': ! passwordHasLengthSpan(password, 16, 32) }"
                        />
                        {{ lang('Mellan 16 och 32 tecken', 'Between 16 and 32 characters') }}
                    </div>
                    <div class="mt-sm">
                        <font-awesome-icon
                            icon="check-circle"
                            class="mr-xs"
                            :class="{'text-success': passwordMatchesConfirmed(password), 'text-neutral-light': ! passwordMatchesConfirmed(password) }"
                        />
                        {{ lang('Bekräftelsen matchar', 'Passwords match') }}
                    </div>
                </div>
            </template>
        </password-input>

        <password-input
            v-model="passwordConfirmation"
            :label="lang('Bekräfta lösenord','Confirm password')"
            type="password"
            name="password_confirmation"
            autocomplete="new-password"
            required
            :tabindex="2"
            :can-toggle-visibility="true"
            :show-password-strength="false"
        />
    </div>
</template>
<script>
export default {
    props: {
        name: {
            required: false,
            type: String,
            default: 'password',
        },
        value: {
            required: false,
            type: String,
            default: '',
        },
    },
    data() {
        return {
            localValue: this.value,
            passwordConfirmation: null,
        };
    },
    computed: {
        isPasswordValidAndConfirmed() {
            const valid = this.passwordHasLowercase(this.value)
                && this.passwordHasUppercase(this.value)
                && this.passwordHasSpecialCharacter(this.value)
                && this.passwordHasNumber(this.value)
                && this.passwordHasLengthSpan(this.value, 16, 32)
                && this.passwordMatchesConfirmed(this.value);

            return valid;
        },
    },
    watch: {
        // Watch the prop for external changes
        value(newValue) {
            this.localValue = newValue;
        },
        // Watch local value and emit changes
        localValue(newValue) {
            this.$emit('input', newValue);
        },
        passwordConfirmation(newValue) {
            this.$emit('password-confirmation-update', newValue);
        },
        isPasswordValidAndConfirmed: {
            handler(newValue) {
                this.$emit('validation-change', newValue && this.isPasswordValidAndConfirmed);
            },
            immediate: true,
        },
    },
    methods: {
        passwordHasLowercase(password) {
            if (!password) {
                return false;
            }

            return password.match(/[a-z]/) !== null;
        },

        passwordHasUppercase(password) {
            if (!password) {
                return false;
            }

            return password.match(/[A-Z]/) !== null;
        },

        passwordHasLengthSpan(password, min, max) {
            if (!password) {
                return false;
            }

            return password.length >= min && password.length <= max;
        },

        passwordHasSpecialCharacter(password) {
            if (!password) {
                return false;
            }

            return password.match(/[^a-zA-Z0-9]/) !== null;
        },

        passwordHasNumber(password) {
            if (!password) {
                return false;
            }

            return password.match(/[0-9]/) !== null;
        },
        passwordMatchesConfirmed(password) {
            if (!password) {
                return false;
            }

            return password === this.passwordConfirmation;
        },
    },
};
</script>
